var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('close-tariff', {
    attrs: {
      "on-close": _vm.handleCloseTariff,
      "tariff": _vm.tariff && _vm.tariff.title,
      "btnIsDisabled": _vm.btnIsDisabled
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dadd528","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestProducts/CloseTariffContainer.vue
// module id = 983
// module chunks = 0